import React from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";

const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const ErrorModal = ({ openErrorModal, handleCloseErrorModal, errorMessage }) => {
  const classes = useStyles();
  return (
    <Modal
      key="error-modal"
      className={classes.modal}
      open={openErrorModal}
      onClose={handleCloseErrorModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={openErrorModal}>
        <div className={classes.paper}>
          <h2>Internal Error</h2>
          <p>{errorMessage}</p>
        </div>
      </Fade>
    </Modal>
  );
};

ErrorModal.defaultProps = {
  errorMessage: "",
};

ErrorModal.propTypes = {
  openErrorModal: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
  handleCloseErrorModal: PropTypes.func.isRequired,
};
export default ErrorModal;
